import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ServiceUsagesGroup_Remove_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ServiceUsagesGroup_Remove(
      $serviceUsagesGroupId: Id!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      removeMissionServiceUsagesGroup(
        serviceUsagesGroupId: $serviceUsagesGroupId
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useRemoveMissionServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ServiceUsagesGroup_Remove_Mutation,
  );
